<template>
  <div
    :class="[
      'carousel-arrows',
      orientation,
      {
        start: value === count - 1 && !loop,
        end: value === 0 && !loop,
      },
    ]"
  >
    <IconButton
      v-if="value > 0 || loop"
      :name="orientation === 'horizontal' ? 'chevron-left' : 'chevron-up'"
      :size="36"
      type="outline"
      :color="color"
      class="carousel-arrows-icon"
      @click.native="handlePrevious"
    />
    <IconButton
      v-if="value < count - 1 || loop"
      :name="orientation === 'horizontal' ? 'chevron-right' : 'chevron-down'"
      :size="36"
      type="outline"
      :color="color"
      class="carousel-arrows-icon"
      @click.native="handleNext"
    />
  </div>
</template>

<script>  
import IconButton from '@/lego/components/buttons/IconButton.vue';
import { toRefs } from '@vue/composition-api';

export default {
  components: { IconButton },

  props: {
    value: {
      type: Number,
      required: true,
    },

    count: {
      type: Number,
      default: 0,
    },

    orientation: {
      type: String,
      default: 'horizontal',
    },

    color: {
      type: String,
      default: 'white',
    },

    loop: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { value, count, orientation, color, loop } = toRefs(props);

    const handlePrevious = () => {
      if (value.value > 0) {
        emit('input', value.value - 1);
      } else if (loop.value) {
        emit('input', count.value - 1);
      }
    };

    const handleNext = () => {
      if (value.value < count.value - 1) {
        emit('input', value.value + 1);
      } else if (loop.value) {
        emit('input', 0);
      }
    };

    return { handlePrevious, handleNext };
  },
};
</script>

<style scoped lang="postcss">
.carousel-arrows {
  @apply w-full h-full absolute flex justify-between items-center z-10 p-xxs gap-x-micro pointer-events-none;

  &.horizontal {
    @apply flex-row;
  }

  &.vertical {
    @apply flex-col;
  }

  &.start {
    @apply justify-start;
  }

  &.end {
    @apply justify-end;
  }

  &-icon {
    @apply cursor-pointer transition-all opacity-80 pointer-events-auto;

    &:hover {
      @apply opacity-100;
    }
  }
}
</style>
